import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { axios, queryClient } from '@apps-common/lib'
import { IPortalOrderFilterProps } from '@apps-common/stores'
import { IOrderListModel } from '@apps-common/types/portal/order'

export const QUERY_SEARCH_ORDERS_INFINITE = (
  companyId?: string,
  orderNo?: string,
  startDate?: string | null,
  endDate?: string | null,
  status?: string,
  skip?: number,
  take?: number
) =>
  [
    'searchOrdersInfinite',
    companyId,
    orderNo,
    startDate,
    endDate,
    status
    // skip,
    // take
  ].filter(Boolean)

export const searchOrders = async (
  companyId: string,
  orderNo: string,
  startDate: string | null,
  endDate: string | null,
  status: string,
  skip: number,
  take: number
): Promise<IOrderListModel[]> =>
  axios
    .get(
      `/Order/Orders?companyId=${companyId}&orderNo=${orderNo}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}&status=${status}&skip=${skip}&take=${take}`
    )
    .then((res) => res.data?.data)

type Props = {
  model: IPortalOrderFilterProps
}

export const useSearchOrdersInfinite = ({ model }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage } = useInfiniteQuery({
    queryKey: QUERY_SEARCH_ORDERS_INFINITE(
      model.companyId,
      model.orderNo,
      model.startDate,
      model.endDate,
      model.status,
      model.skip,
      model.take
    ),
    initialPageParam: 0,
    queryFn: ({ pageParam = 0 }) =>
      searchOrders(model.companyId, model.orderNo, model.startDate, model.endDate, model.status, pageParam, model.take),
    getNextPageParam: (lastPage, allPages) => allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
  })

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: QUERY_SEARCH_ORDERS_INFINITE() })
    },
    []
  )

  return { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage }
}
